export interface Filter {
  key: string;
  value: string;
  description: string;
}

export const generalSearchOptions: Filter[] = [
  { key: 'name', value: 'first name, sur name', description: 'string type' },
  {
    key: 'address',
    value: 'street, house number',
    description: 'address of the object',
  },
  {
    key: 'postcode',
    value: '123456',
    description: 'last 3 digits of the postcode',
  },
  { key: 'city', value: 'amsterdam', description: 'city name' },
  { key: 'iban', value: 'account number', description: 'Bank Account Number' },
  { key: 'email', value: 'john@example.com', description: 'email address' },
  { key: 'phone', value: '+9167654321', description: 'phone number address' },
];

/**
 * Suggested Filters
 */

export const contactSearchOptions: Filter[] = [
  {
    key: 'ProfileId',
    value: 'Profile Id',
    description: 'Profile ID',
  },
  {
    key: 'Name',
    value: 'Name',
    description: 'Contact name',
  },
  {
    key: 'Address',
    value: 'Address',
    description: 'Street address',
  },
  {
    key: 'HouseNumber',
    value: 'House Number',
    description: 'House number',
  },
  {
    key: 'PostCode',
    value: 'Postal Code',
    description: 'Postal code',
  },
  {
    key: 'City',
    value: 'City',
    description: 'City name',
  },
  {
    key: 'Iban',
    value: 'IBAN',
    description: 'International Bank Account Number',
  },
  {
    key: 'Email',
    value: 'Email',
    description: 'Email address',
  },
  {
    key: 'Phone',
    value: 'Phone',
    description: 'Phone number',
  },
  // {
  //   key: 'IsClient',
  //   value: 'Type',
  //   description: 'Client,Handyman',
  // },
];

export const invoiceSearchOptions: Filter[] = [
  {
    key: 'ImportStatus',
    value: 'Status',
    description: 'Open, Imported, Error',
  },
  {
    key: 'TaskId',
    value: 'Task Id',
    description: 'TaskId',
  },
  { key: 'ProfileId', value: 'Profile Id', description: 'Profile Id' },
  {
    key: 'InvoiceDate',
    value: 'Invoice Date  (dd-mm-yyyy)',
    description: 'Invoice Date',
  },
  {
    key: 'ImportDate',
    value: 'Import Date  (dd-mm-yyyy)',
    description: 'Import Date',
  },
  { key: 'Amount', value: 'Amount', description: 'Amount' },
  {
    key: 'EolInvoiceNumber',
    value: 'Eol Invoice Number',
    description: 'Eol Invoice Number',
  },
  {
    key: 'EolContactId',
    value: 'Eol Contact Id',
    description: 'Eol Contact Id',
  },
];

export const importStatusFilters: Filter[] = [
  {
    key: 'Status',
    value: 'Open',
    description: 'Open',
  },
  {
    key: 'Status',
    value: 'Error',
    description: 'Error',
  },
  {
    key: 'Status',
    value: 'Imported',
    description: 'Imported',
  },
  {
    key: 'Status',
    value: 'Open special',
    description: 'Open Special',
  },
];

export const stripeSearchOptions: Filter[] = [
  { key: 'TaskId', value: 'Task Id', description: 'number type' },
  {
    key: 'PaymentDpt',
    value: 'Invoice Number',
    description: 'last four digits of the invoice number',
  },
  { key: 'Amount', value: 'Amount', description: 'amount in euros' },
  {
    key: 'Status',
    value: 'Import Status',
    description: 'Open, Imported , Error',
  },
  // { key: 'exactId', value: '000-0000-000-00000', description: 'exact online id' },
  {
    key: 'StripeId',
    value: 'Stripe Transaction Id',
    description: 'stripe transaction id',
  },
  {
    key: 'CreatedOn',
    value: 'Date (dd-mm-yyyy)',
    description: 'object created on date',
  },
  {
    key: 'PaymentType',
    value: 'Payment Type',
    description:
      'Payments, Transfers, Payouts, Payment reversal, Transfer reversal',
  },
];

export const paymentFilters: Filter[] = [
  {
    key: 'PaymentType',
    value: 'payment',
    description: 'Payments',
  },
  {
    key: 'PaymentType',
    value: 'transfer',
    description: 'Tansfers',
  },
  {
    key: 'PaymentType',
    value: 'payout',
    description: 'Payouts',
  },
  {
    key: 'PaymentType',
    value: 'payment_refund',
    description: 'Payment Refund',
  },
  {
    key: 'PaymentType',
    value: 'transfer_refund',
    description: 'Tansfer Refund',
  },
];

export const statusFilters: Filter[] = [
  {
    key: 'Status',
    value: 'Open',
    description: 'Open',
  },
  {
    key: 'Status',
    value: 'Error',
    description: 'Error',
  },
  {
    key: 'Status',
    value: 'Imported',
    description: 'Imported',
  },

  // {
  //   key: 'Status',
  //   value: 'Tansfer Refund',
  //   description: 'Tansfer Refund',
  // },
];

/**
 * Result Colunms
 */

export const contactsResultColumn = [
  { key: 'id', label: 'Id', sortable: true, sticky: false },
  {
    key: 'profileId',
    label: 'Profile Id',
    sortable: true,
    sticky: false,
  },
  {
    key: 'name',
    label: 'Name',
    sortable: true,
    sticky: false,
  },
  {
    key: 'address',
    label: 'Address',
    sortable: true,
    sticky: false,
  },
  {
    key: 'houseNumber',
    label: 'House Number',
    sortable: true,
    sticky: false,
  },
  {
    key: 'postCode',
    label: 'Postal Code',
    sortable: true,
    sticky: false,
  },
  {
    key: 'city',
    label: 'City',
    sortable: true,
    sticky: false,
  },
  {
    key: 'iban',
    label: 'IBAN',
    sortable: true,
    sticky: false,
  },
  {
    key: 'email',
    label: 'Email',
    sortable: true,
    sticky: false,
  },
  {
    key: 'phone',
    label: 'Phone',
    sortable: true,
    sticky: false,
  },
  {
    key: 'isClient',
    label: 'Type',
    sortable: true,
    sticky: false,
  },
];

export const invoiceResultColumn = [
  { key: 'id', label: 'Id', sortable: true, sticky: false },
  { key: 'importStatus', label: 'Status', sortable: true, sticky: false },
  {
    key: 'taskId',
    label: 'Task Id',
    sortable: true,
    sticky: false,
  },
  { key: 'profileId', label: 'Profile Id', sortable: true, sticky: false },
  { key: 'invoiceDate', label: 'Invoice Date', sortable: true, sticky: false },
  { key: 'importDate', label: 'Import Date', sortable: true, sticky: false },
  { key: 'amount', label: 'Amount', sortable: true, sticky: false },
  {
    key: 'eolInvoiceNumber',
    label: 'Eol Invoice Number',
    sortable: true,
    sticky: false,
  },
  {
    key: 'eolContactId',
    label: 'Eol Contact Id',
    sortable: true,
    sticky: false,
  },
];

export const stripeSearchResultColumn = [
  { key: 'id', label: 'Id', sortable: true, sticky: false },
  { key: 'taskId', label: 'Task Id', sortable: true },
  { key: 'invoiceNo', label: 'Invoice No', sortable: true },
  {
    key: 'stripeTransactionId',
    label: 'Stripe Transaction Id',
    sortable: true,
    sticky: false,
  },
  { key: 'paymentType', label: 'Payment Type', sortable: true, sticky: false },
  { key: 'amount', label: 'Amount', sortable: true },
  { key: 'status', label: 'Import Status', sortable: true },
  {
    key: 'date',
    label: 'Invoice Date  (dd-mm-yyyy)',
    sortable: true,
    sticky: false,
  },
];
